import styled from 'styled-components'

export const RadarContainer = styled.div<{ size?: number }>`
  width: ${(props) => props.size || 200}px;
  height: ${(props) => props.size || 200}px;
  position: relative;
`
